// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","443":"about","631":"contact","821":"pagina"}[chunkId] + "." + {"177":"e1764cad","443":"e1764cad","631":"e1764cad","821":"e1764cad"}[chunkId] + ".css";
};